import React from 'react';
import { ServiceItemProps } from '../services.props';
import { Button, Chip, Div, Media, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';

const ServiceItem = ({ item, isActive, isUpdating = false, hasTutorial = true, buttonsTitle, chipsTitle, comingSoon = false }: ServiceItemProps) => {
  if (!isActive) {
    return null;
  }
  return (
    <Div className={'items-center justify-between mx-1 my-2 relative at-lg:flex-col'}>
      <Div className={'relative object-contain min-w-[128px] w-32 h-32 sm:min-w-[144px] sm:w-36 sm:h-36 md:min-w-[176px] md:w-44 md:h-44 items-center justify-center'}>
        <Image
          alt={'logo'}
          src={item?.icon}
          sizes={'(max-width: 639px) 33vw, (max-width: 1023px) 25vw, 20vw'}
        />
        {item.hasInsurance ? (
          <Chip
            className={'absolute bottom-0 z-[4]'}
            textProps={{ typography: 'sm' }}
            color={'secondary'}
            variant={'reverse'}
            value={chipsTitle.insurance}/>
        ) : null}
        {isUpdating ? (
          <Chip
            className={'absolute bottom-0 z-[4]'}
            textProps={{ typography: 'sm' }}
            color={'slate'}
            variant={'reverse'}
            value={chipsTitle.updating}/>
        ) : null}
        {comingSoon ? (
          <Chip
            className={'absolute top-0 z-[4]'}
            textProps={{ typography: 'sm' }}
            color={'danger'}
            variant={'reverse'}
            value={chipsTitle.coming_soon}/>
        ) : null}
      </Div>
      <Div className={'items-center flex-col w-full'}>
        <Div className={'my-4 flex-col'}>
          <Text className={'whitespace-nowrap'} type={'bold'} typography={'lg'}>
            {item?.title}
          </Text>
          <Text className={'whitespace-nowrap'} color={'grey.600'} typography={'sm'}>
            {item?.subtitle}
          </Text>
        </Div>
        <Div className={'my-4 flex-col gap-2 md:gap-6 w-full items-center'}>
          <Button disabled={isUpdating || comingSoon} href={item?.link} onClick={item?.onClick} className={'w-full max-w-[172px]'}>
            {buttonsTitle.get}
          </Button>
          <Media greaterThan={'xs'} className={'w-full justify-center'}>
            <Button onClick={item?.onTutorialClick} disabled={isUpdating || !hasTutorial || comingSoon} color={'control'} variant={'outlined'} className={'w-full max-w-[172px]'}>
              {buttonsTitle.video_tutorial}
            </Button>
          </Media>
        </Div>
      </Div>
    </Div>
  );
};

export default ServiceItem;
